import Type from "@/model/types/Type";


const type = {
    BEFORE: 10,
    AFTER: 50,

}

const list = [
    {
        value: type.BEFORE,
        text: "Início do relatório",
    },
    {
        value: type.AFTER,
        text: "Fim do relatório",

    },
]
const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains
}